module.exports = __webpack_public_path__ + "static/media/inline.d4064aa2.svg";